var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFillNotification = function SvgUserFillNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    d: "M24 4c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10S29.514 4 24 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    fillRule: "evenodd",
    d: "M36.97 29.26A8.003 8.003 0 0 0 32.755 42H6v-2c0-7.718 6.28-14 14-14h8c3.41 0 6.539 1.226 8.97 3.26",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 37,
    r: 5,
    fill: "#EDBE62"
  })));
};
export { SvgUserFillNotification as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDRDMTguNDg2IDQgMTQgOC40ODYgMTQgMTRDMTQgMTkuNTE0IDE4LjQ4NiAyNCAyNCAyNEMyOS41MTQgMjQgMzQgMTkuNTE0IDM0IDE0QzM0IDguNDg2IDI5LjUxNCA0IDI0IDRaIiBmaWxsPSIjMjgzRTRDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzYuOTY5OCAyOS4yNTk5QzMzLjUzNDcgMzAuMTU4NCAzMSAzMy4yODMyIDMxIDM3QzMxIDM4Ljg5MTkgMzEuNjU2NyA0MC42MzA0IDMyLjc1NDYgNDJIMTBINlY0MEM2IDMyLjI4MiAxMi4yOCAyNiAyMCAyNkgyOEMzMS40MDk0IDI2IDM0LjUzODYgMjcuMjI1OSAzNi45Njk4IDI5LjI1OTlaIiBmaWxsPSIjMjgzRTRDIi8+CjxjaXJjbGUgY3g9IjM5IiBjeT0iMzciIHI9IjUiIGZpbGw9IiNFREJFNjIiLz4KPC9zdmc+Cg==";